export interface ISentryVars {
  appDsn: string;
  webDsn: string;
  apiDsn: string;
  identityDsn: string;
  org: string;
  appProject: string;
  webProject: string;
  apiProject: string;
  identityProject: string;
}

export const sentryVars: ISentryVars = {
  appDsn:
    'https://8f628f0552f71fa4ed103175b099b30d@o4511072719077376.ingest.de.sentry.io/4511072735461456',
  webDsn:
    'https://069c7a3fe0b4a1d5a51d3a5391173500@o4511072719077376.ingest.de.sentry.io/4511072730677328',
  apiDsn:
    'https://b0709d6fbbb186b58ac31dd9af6b0346@o4511072719077376.ingest.de.sentry.io/4511578869792848',
  identityDsn:
    'https://8939d2961abb32f08d7ea98d0d09fcb4@o4511072719077376.ingest.de.sentry.io/4511578878181456',
  org: 'cool-mate',
  appProject: 'coolmate-app',
  webProject: 'coolmate-web',
  apiProject: 'coolmate-api',
  identityProject: 'coolmate-identity',
};
